import * as React from "react";
import { Path } from "react-native-svg";
import { Icon, IIconProps } from "native-base";

const CheckedNoCont = (props: IIconProps) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <Path
      d="M16.2956 10.6837L11.5004 15.4994C11.1157 15.8857 10.4906 15.8871 10.1043 15.5024C10.0674 15.4657 10.034 15.4268 10.0042 15.3861L7.29074 12.6817C6.904 12.2962 6.90295 11.6702 7.28841 11.2835C7.67387 10.8967 8.29986 10.8957 8.6866 11.2811L10.8149 13.3896L14.8965 9.29063C15.2812 8.90429 15.9063 8.90296 16.2926 9.28765C16.6789 9.67235 16.6803 10.2974 16.2956 10.6837Z"
      fill={"currentColor"}
    />
  </Icon>
);

export default CheckedNoCont;
